import { E as v, Z as L, _ as S, Ht as g, or as o, f as $, sr as A } from "./abstract-base-0be59b32-472aea73.js";
import { e as u } from "./state-69dd4009-f645ce71.js";
import { i as N } from "./query-24926cff-3eb94bfb.js";
import { E as B } from "./keys-b2183e45-74d07070.js";
import { l as k } from "./orientations-42163445-a7edd586.js";
import { r as T, i as D, y as I, s as x } from "./lifecycle-decorators-ecc4e836-92da4b80.js";
import { A as P } from "./query-assigned-1d8bbbb5-2e84a5b4.js";
import { r as E } from "./utils-2e24a437-adde688b.js";
var f = /* @__PURE__ */ ((t) => (t.CLICK = "click", t.HOVER = "hover", t.MANUAL = "manual", t))(f || {}), c = /* @__PURE__ */ ((t) => (t.START = "start", t.CENTER = "center", t.END = "end", t))(c || {}), z = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(z || {}), r = /* @__PURE__ */ ((t) => (t.BlockStart = "block-start", t.InlineStart = "inline-start", t.BlockEnd = "block-end", t.InlineEnd = "inline-end", t))(r || {});
function j(t, a) {
  return t.has(a) && typeof t.get(a) < "u";
}
var W = Object.defineProperty, K = Object.getOwnPropertyDescriptor, s = (t, a, i, h) => {
  for (var l = h > 1 ? void 0 : h ? K(a, i) : a, e = t.length - 1, n; e >= 0; e--)
    (n = t[e]) && (l = (h ? n(a, i, l) : n(l)) || l);
  return h && l && W(a, i, l), l;
};
const _ = (t) => function(a) {
  let i = class extends a {
    constructor() {
      super(...arguments), this.orientation = k.VERTICAL, this.trigger = f.HOVER, this.isOpen = !1, this.content = "", this.alignment = c.CENTER, this.direction = r.InlineStart, this.topOffset = 0, this.leftOffset = 0, this.RTL = !1, this.marginAdjust = 0, this.targetSelectorString = ".overlay-target", this.debouncedCalculateOffset = E(this.calculateOffset.bind(this), 100), this.toggleClick = () => {
        this.isOpen ? this.close() : this.open();
      }, this.intersectionObserver = new IntersectionObserver(this.debouncedCalculateOffset, { threshold: 1 }), this.resizeObserver = new ResizeObserver(this.debouncedCalculateOffset), this.open = t && !t.disableDebounceOpen ? E(() => {
        this.calculateOffset(), this.isOpen = !0, this.emitOpen();
      }, 100) : () => {
        this.calculateOffset(), this.isOpen = !0, this.emitOpen();
      }, this.handleKeydown = (e) => {
        e.isTrusted && this.isOpen && (super.handleKeydown(), this.closeOnEscape(e));
      }, this.handleExternalClick = (e) => {
        this.isOpen && this.isOutsideOverlay(e.target) && this.close();
      };
    }
    get targetSelector() {
      return this.targetSelectorString;
    }
    set targetSelector(e) {
      this.targetSelectorString = e;
    }
    get viewportRect() {
      var e;
      return (e = this.viewportRectObj) != null ? e : document.documentElement.getBoundingClientRect();
    }
    set viewportRect(e) {
      this.viewportRectObj = e;
    }
    set targetRect(e) {
      this.targetRectObj = e;
    }
    get scrollListeningContainer() {
      var e;
      return (e = this.scrollListeningContainerObj) != null ? e : window;
    }
    set scrollListeningContainer(e) {
      this.scrollListeningContainerObj = e;
    }
    get overlaySelector() {
      return ".overlay-wrapper";
    }
    get overlayName() {
      return "overlay";
    }
    get externalClickNode() {
      return this.getRootNode();
    }
    static get overlayStyles() {
      return [];
    }
    /**
     * Calculates margin adjustment for when the overlay component is visible
     * @param marginToken token representing the margin of the overlay component
     * @param arrowSizeToken token representing the size of the arrow on the overlay
     */
    computeMarginAdjustment(e, n) {
      this.marginAdjust = parseInt(e, 10) + parseInt(n, 10) / 2;
    }
    /**
     * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
     * @param target DOMRect of the target element
     * @param overlay DOMRect of the overlay element
     */
    computeDirection(e, n) {
      this.orientation === k.VERTICAL ? (e.y < this.viewportRect.height / 4 ? this.direction = r.BlockStart : this.direction = r.BlockEnd, e.x < this.viewportRect.width / 4 ? this.alignment = c.START : e.x > this.viewportRect.width * 3 / 4 ? this.alignment = c.END : this.alignment = c.CENTER) : (this.alignment = c.CENTER, this.RTL ? this.viewportRect.width < e.x ? this.direction = r.InlineEnd : this.direction = r.InlineStart : e.x + e.width + n.width < this.viewportRect.width ? this.direction = r.InlineStart : this.direction = r.InlineEnd);
    }
    /**
     * @param overlayWidth Width of the Overlay element
     * @param targetWidth Width of the Target Element
     * @returns Based on Alignment, will return leftOffset as number.
     */
    calculateHorizontalOffset(e, n) {
      const p = n - e, d = e / 2 - this.marginAdjust;
      switch (this.alignment) {
        case c.START:
          return p / 2 + d;
        case c.CENTER:
          return p / 2;
        case c.END:
          return p / 2 - d;
        default:
          return 0;
      }
    }
    /**
     * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
     * @abstract
     */
    calculateOffset() {
      var e, n, p;
      const d = (e = this.shadowRoot) == null ? void 0 : e.querySelector(this.targetSelector), b = (n = this.shadowRoot) == null ? void 0 : n.querySelector(this.overlaySelector);
      if (b && (d || this.targetRectObj)) {
        const w = (p = this.targetRectObj) != null ? p : d == null ? void 0 : d.getBoundingClientRect(), R = b.getBoundingClientRect();
        this.computeDirection(w, R);
        const { height: y, width: m } = w, { height: O, width: C } = R;
        switch (this.topOffset = 0, this.leftOffset = m, this.direction) {
          case r.BlockEnd:
            this.topOffset = -1 * (y + O), this.leftOffset = this.calculateHorizontalOffset(C, m);
            break;
          case r.BlockStart:
            this.leftOffset = this.calculateHorizontalOffset(C, m);
            break;
          case r.InlineEnd:
            this.leftOffset = -1 * C, this.topOffset = -1 * (O + (y - O) / 2);
            break;
          case r.InlineStart:
            this.topOffset = -1 * (O + (y - O) / 2);
            break;
        }
      }
    }
    /**
     * Enables overlay surface to reposition and reorient based on:
     * 1. When overlayWrapper is intersecting with viewport border
     * 2. When document body is resized
     * 3. When user scrolls
     */
    engageDynamicOverlayPositioning() {
      this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Disengages dynamic overlay positioning by unobserving by:
     * 1. Unobserving overlayWrapper intersections with viewport
     * 2. Unobserving resize of the document body
     * 3. Removing scroll event listener from scrollListeningContainer
     */
    disengageDynamicOverlayPositioning() {
      this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Destroys dynamic overlay positioning by:
     * 1. Disconnecting intersection observer
     * 2. Disconnecting resize observer
     * 3. Removing scroll event listener from scrollListeningContainer
     * This method is intended for use when disconnecting component.
     */
    destroyDynamicOverlayPositioning() {
      this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
    }
    /**
     * Makes the overlay hidden.
     */
    close() {
      this.isOpen = !1;
    }
    /** Closes the popover when the key pressed is the escape key. */
    closeOnEscape(e) {
      e.key === B.ESCAPE && this.close();
    }
    /**
     * @param node target element
     * @returns whether the target element is outside of the overlay content
     */
    isOutsideOverlay(e) {
      if (this.overlayWrapper.contains(e) || this.contains(e))
        return !1;
      const n = e.getRootNode();
      return !(n instanceof ShadowRoot && this.contains(n.host));
    }
    /**
     * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
     */
    emitClose() {
      L(this, S.CLOSE, !!this.onBeaconClose && this.onBeaconClose());
    }
    /**
     * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
     */
    emitOpen() {
      L(this, S.OPEN, !!this.onBeaconOpen && this.onBeaconOpen());
    }
    /**
     * Lit lifecycle hook to handle changing of properties
     */
    updated(e) {
      j(e, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
    }
    overlayPrerender() {
      this.isOpen && this.open(), this.externalClickNode.addEventListener(g.CLICK, this.handleExternalClick), this.externalClickNode.addEventListener(g.KEYDOWN, this.handleKeydown);
    }
    overlayPostrender() {
      this.calculateOffset();
    }
    overlayDestroy() {
      this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(g.KEYDOWN, this.handleKeydown), this.externalClickNode.removeEventListener(g.CLICK, this.handleExternalClick);
    }
    /**
     * Render template: slotted element
     */
    renderSlot() {
      return this.trigger === f.HOVER ? o`<slot @mouseover=${this.open} @mouseout=${this.close}></slot>` : this.trigger === f.CLICK ? o`<slot @click=${this.toggleClick}></slot>` : o`<slot></slot>`;
    }
    /**
     * Render template: overlay content
     */
    renderOverlayContent() {
      return o`<p>${this.content}</p>`;
    }
    /**
     * Render template: overlay content skeleton
     */
    renderContentWrapper() {
      return o`<div class="tooltip-content" aria-live="${this.isOpen ? "polite" : "off"}">${this.renderOverlayContent()}</div>`;
    }
    /**
     * Render template: arrow
     * @todo align the arrow implementation with the navigation popover arrow
     */
    renderArrow() {
      return o`<span class="overlay-arrow ${this.alignment}" aria-hidden="true"></span>`;
    }
    /**
     * Render template: entire overlay skeleton
     */
    renderOverlayWrapper() {
      return this.style.setProperty("--left-offset", `${this.leftOffset}px`), this.style.setProperty("--top-offset", `${this.topOffset}px`), o`<div
          id="${this.overlayName}"
          role="tooltip"
          aria-hidden="${this.isOpen ? "false" : "true"}"
          class="overlay-wrapper ${this.direction}"
        >
          ${this.renderArrow()} ${this.renderContentWrapper()}
        </div>`;
    }
    /**
     * Render template: overlay and target
     */
    render() {
      return o`${this.trigger === f.MANUAL ? $ : o`<div class="overlay-target" aria-describedBy="${this.overlayName}">${this.renderSlot()}</div>`}
        ${this.renderOverlayWrapper()}`;
    }
  };
  s([
    v()
  ], i.prototype, "orientation", 2), s([
    v()
  ], i.prototype, "trigger", 2), s([
    v({ type: Boolean, reflect: !0, attribute: "is-open" })
  ], i.prototype, "isOpen", 2), s([
    v()
  ], i.prototype, "content", 2), s([
    v({ type: Function })
  ], i.prototype, "onBeaconClose", 2), s([
    v({ type: Function })
  ], i.prototype, "onBeaconOpen", 2), s([
    u()
  ], i.prototype, "alignment", 2), s([
    u()
  ], i.prototype, "direction", 2), s([
    u()
  ], i.prototype, "topOffset", 2), s([
    u()
  ], i.prototype, "leftOffset", 2), s([
    u()
  ], i.prototype, "RTL", 2), s([
    N(".overlay-wrapper")
  ], i.prototype, "overlayWrapper", 2), s([
    T
  ], i.prototype, "overlayPrerender", 1), s([
    D
  ], i.prototype, "overlayPostrender", 1), s([
    I
  ], i.prototype, "overlayDestroy", 1), i = s([
    x("Overlay")
  ], i);
  class h extends i {
    constructor() {
      super(...arguments), this.open = t && !t.disableDebounceOpen ? E(async () => {
        this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0;
      }, 100) : async () => {
        this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0;
      };
    }
    /**
     * Handle close and return focus to active element.
     * Also removes listener and observer logic when overlay closed for better performance.
     */
    close() {
      super.close(), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
    }
    /**
     * Handle dark mode theming in action zone
     */
    setActionZoneDarkMode() {
      this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach((e) => {
        e.classList.contains("beacon-on-dark") || e.classList.add("beacon-on-dark");
      });
    }
    /**
     * Focuses on the previously active element
     */
    focusOnActiveElement() {
      var e;
      (e = this.activeElement) == null || e.focus();
    }
    /**
     * Render template: close icon button
     */
    renderCloseButton() {
      return A`<${this.getScopedTag("beacon-icon-button")}
                variant="tertiary"
                label="Close Button"
                class="beacon-popover-close-button beacon-on-dark"
                @beacon-event-click="${this.close}"
                >
                <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"/>
                </svg>
                </${this.getScopedTag("beacon-icon-button")}>
                `;
    }
    /**
     * Render template: adjusts content wrapper
     */
    renderContentWrapper() {
      return o`<div class="beacon-popover-surface">
          ${this.renderCloseButton()}
          <div class="beacon-popover-zones-wrapper" aria-live="${this.isOpen ? "polite" : "off"}">${this.renderOverlayContent()}</div>
        </div>`;
    }
    /**
     * Render template: slot with only click event
     */
    renderSlot() {
      return o`<slot @click=${this.toggleClick}></slot>`;
    }
  }
  return s([
    u()
  ], h.prototype, "activeElement", 2), s([
    P({ flatten: !0, slot: "actionzone" })
  ], h.prototype, "slottedActionzone", 2), t && t.interactive ? h : i;
};
export {
  f as O,
  _ as Y,
  j,
  c as l,
  r as n,
  z
};
